module.exports = __webpack_public_path__ + "static/media/f8.e446db7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f8.png
// module id = 1219
// module chunks = 0